<div class="sitemap container py-4" [attr.dir]="isRtl ? 'rtl' : 'ltr'">
  <h1 class="sitemap__title uc-display-sm uc-semibold" translate="unifiedShell.sitemap.title"></h1>
  <p class="sitemap__intro" translate="unifiedShell.sitemap.intro"></p>

  <div class="sitemap__sections">
    <section *ngFor="let section of sections; trackBy: trackById" class="sitemap__section"
      [attr.aria-labelledby]="'sitemap-' + section.id">
      <h2 [id]="'sitemap-' + section.id" class="sitemap__heading uc-text-xl uc-semibold">{{ section.headingKey | translate }}</h2>

      <ul *ngIf="section.links?.length" class="sitemap__list">
        <ng-container *ngFor="let link of section.links; trackBy: trackById">
          <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: link }"></ng-container>
        </ng-container>
      </ul>

      <ng-container *ngFor="let group of section.groups; trackBy: trackById">
        <h3 [id]="'sitemap-group-' + group.id" class="sitemap__subheading uc-text-md uc-semibold">
          {{ group.headingKey ? (group.headingKey | translate) : groupHeading(group) }}
        </h3>
        <ul class="sitemap__list" [attr.aria-labelledby]="'sitemap-group-' + group.id">
          <ng-container *ngFor="let link of group.links; trackBy: trackById">
            <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: link }"></ng-container>
          </ng-container>
        </ul>
      </ng-container>
    </section>
  </div>
</div>

<ng-template #linkItem let-link>
  <li class="sitemap__item">
    <a *ngIf="link.url" class="sitemap__link" [routerLink]="link.url">{{ link.labelKey ? (link.labelKey | translate) : linkText(link) }}</a>
    <a *ngIf="link.href" class="sitemap__link" [href]="link.href" target="_blank" data-uc-external-icon rel="noopener">
      {{ link.labelKey ? (link.labelKey | translate) : linkText(link) }}
      <i class="fa-solid fa-arrow-up-right-from-square uc-external-icon" aria-hidden="true"></i>
    </a>
    <ul *ngIf="link.children?.length" class="sitemap__list sitemap__list--nested">
      <ng-container *ngFor="let child of link.children; trackBy: trackById">
        <ng-container *ngTemplateOutlet="linkItem; context: { $implicit: child }"></ng-container>
      </ng-container>
    </ul>
  </li>
</ng-template>
